import React from "react";
import { COLORS } from "@/constants";
import { reportError } from "@/utils/helper/error-reporter";

interface RouteErrorBoundaryState {
  hasError: boolean;
}

// Without a boundary, a rejected lazy import — typically a stale webview
// session requesting a hashed chunk that a redeploy deleted — unmounts the
// whole tree into a silent white screen. A reload fetches the fresh
// index.html and matching chunks.
export class RouteErrorBoundary extends React.Component<
  { children: React.ReactNode },
  RouteErrorBoundaryState
> {
  state: RouteErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): RouteErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    reportError(error, { extra: { source: "RouteErrorBoundary" } });
  }

  render(): React.ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100dvh",
          padding: 24,
          textAlign: "center",
          color: COLORS.text.pagePrimary,
          backgroundColor: COLORS.background.bodyDefault,
        }}
      >
        <div>เกิดข้อผิดพลาดในการโหลดหน้า กรุณาลองใหม่อีกครั้ง</div>
        <button
          type="button"
          onClick={() => globalThis.location.reload()}
          style={{
            padding: "10px 24px",
            borderRadius: 999,
            border: "none",
            fontWeight: 700,
            fontSize: 15,
            cursor: "pointer",
            color: COLORS.button.primaryColor,
            background: COLORS.button.primaryBackground,
          }}
        >
          ลองใหม่
        </button>
      </div>
    );
  }
}
